import { track as vercelTrack } from "@vercel/analytics";
import type { Track } from "@wb/ui/analytics/track";

export const track: Track = (eventName) => {
  vercelTrack(eventName);
};
